// intercom-initializer.provider.ts
import { inject, provideAppInitializer } from '@angular/core';
import Intercom from '@intercom/messenger-js-sdk';
import { EnvironmentService } from '@app/core/environment/services/environment.service';

export function initializeIntercom(envService: EnvironmentService): () => void {
  return () => {
    if (envService.intercomAppId) {
      Intercom({ app_id: envService.intercomAppId });
    }
  };
}

export const INTERCOM_INITIALIZER = provideAppInitializer(() => {
  const envService = inject(EnvironmentService);
  return initializeIntercom(envService)();
});
